
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiEsperienzeDashboardDialog extends Serenity.EntityDialog<UtentiProdottiEsperienzeDashboardRow, any> {
        protected getFormKey() { return UtentiProdottiEsperienzeDashboardForm.formKey; }
        protected getIdProperty() { return UtentiProdottiEsperienzeDashboardRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiEsperienzeDashboardRow.localTextPrefix; }
        protected getService() { return UtentiProdottiEsperienzeDashboardService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiEsperienzeDashboardRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiEsperienzeDashboardRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiEsperienzeDashboardRow.updatePermission; }

        protected form = new UtentiProdottiEsperienzeDashboardForm(this.idPrefix);

        /**
         * This method is actually the one that calls getEntityTitle()
         * and updates the dialog title. We could do it here too...
         */
        protected updateTitle(): void {

            //super.updateTitle();

            // remove super.updateTitle() call above and uncomment 
            // below line if you'd like to use this version
            // 
            this.dialogTitle = 'Dashbord dell\'esperienza';
        }

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            //Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }

    }
}